<div class="customer-strike-container" *ngIf="!isLabelsLoading">
	<div class="header-wrap">
		<span class="tab selected">{{ labels.lbl_configuracao_de_strike }}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="!isLoadingStrike">
			<div class="search-container">
				<div class="content-container">
					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>{{ labels.lbl_modo_de_contagem_de_strike }}</th>
									<th>{{ labels.lbl_quantos_strikes_por_dia }}</th>
									<th>{{ labels.lbl_intervalo_entre_strikes }}</th>
									<th>{{ labels.lbl_bulletin_actions }}</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngIf="strikeManager.length > 0">
									<tr class="select-bond" *ngFor="let item of strikeManager; let indexItem = index">
										<td class="truncate-text" [title]="item.enable_3strikes">
											<ng-container *ngIf="item.enable_3strikes === 0">{{ labels.lbl_sem_strike }}</ng-container>
											<ng-container *ngIf="item.enable_3strikes === 1">{{
												labels.lbl_asset_automatico
											}}</ng-container>
											<ng-container *ngIf="item.enable_3strikes === 2">{{ labels.lbl_asset_manual }}</ng-container>
										</td>
										<td class="truncate-text" [title]="item.strikes_attempt">
											<ng-container *ngIf="item.strikes_attempt === 1">{{ labels.lbl_uma_vez_ao_dia }}</ng-container>
											<ng-container *ngIf="item.strikes_attempt === 2">{{
												labels.lbl_duas_vezes_ao_dia
											}}</ng-container>
											<ng-container *ngIf="item.strikes_attempt === 3">{{
												labels.lbl_tres_vezes_ao_dia
											}}</ng-container>
										</td>
										<td class="truncate-text" [title]="item.strikes_interval">
											{{ convertToHours(item.strikes_interval) }} {{ labels.lbl_geral_horas }}
										</td>
										<td><fa-icon [icon]="icons.faPencil" (click)="openUpdatedForm(item)"></fa-icon></td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div class="content-container" *ngIf="showEditForm">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_modo_de_contagem_de_strike }}*</span>
					<select (change)="formUpdate.enable_3strikes = $event.target.value">
						<option [value]="null" disabled="disabled">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="0" [selected]="formUpdate.enable_3strikes == 0">{{ labels.lbl_sem_strike }}</option>
						<option [value]="1" [selected]="formUpdate.enable_3strikes == 1">{{ labels.lbl_asset_automatico }}</option>
						<option [value]="2" [selected]="formUpdate.enable_3strikes == 2">{{ labels.lbl_asset_manual }}</option>
					</select>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_quantos_strikes_por_dia }}*</span>
					<select (change)="formUpdate.strikes_attempt = $event.target.value">
						<option [value]="0" [selected]="formUpdate.strikes_attempt == '0'" disabled="disabled">
							{{ labels.lbl_geral_selecione }}
						</option>
						<option [value]="1" [selected]="formUpdate.strikes_attempt == '1'">{{ labels.lbl_uma_vez_ao_dia }}</option>
						<option [value]="2" [selected]="formUpdate.strikes_attempt == '2'">{{ labels.lbl_duas_vezes_ao_dia }}</option>
						<option [value]="3" [selected]="formUpdate.strikes_attempt == '3'">{{ labels.lbl_tres_vezes_ao_dia }}</option>
					</select>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_intervalo_entre_strikes }}*</span>
					<input
						mask="Hh:mm"
						(change)="formUpdate.strikes_interval = $event.target.value"
						[placeholder]="convertToHours(formUpdate.strikes_interval)" />
				</div>
				<div class="button-container">
					<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="saveModification(formUpdate)">
						{{ labels.lbl_geral_atualizar }}
						<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLabelsLoading || isLoadingStrike"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
